/**
 * Chart colours are referenced as CSS custom properties, not as hex literals.
 *
 * Recharts passes `stroke` and `fill` straight through to SVG attributes, so
 * `var(--chart-1)` resolves in the browser and follows the light or dark theme
 * with no JavaScript, no re-render and no flash on toggle. Reading the computed
 * value into React state would reintroduce all three.
 */

export const SERIES_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
] as const;

export function seriesColor(index: number): string {
  const color = SERIES_COLORS[index % SERIES_COLORS.length];
  return color ?? SERIES_COLORS[0];
}

export const GRID_COLOR = 'var(--chart-grid)';
export const AXIS_COLOR = 'var(--chart-axis)';

/**
 * One height for every chart slot, shared with the loading skeleton. A skeleton
 * that is not the same height as its chart makes the page jump when data lands,
 * which reads as slower than it is.
 */
export const CHART_HEIGHT = 260;
export const MINI_CHART_HEIGHT = 120;
